import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Input, Select } from '../../fields'
import { get } from 'lodash'
import { mapActivitiesCategories, mapActivitiesParents } from '../../../redux/selectors/activities'
import { ACTIVITY_CATEGORIES } from '../../../constants/enums'
import { apiActivities, apiCodeLists } from '../../../helpers/decorators/api'
import { connect } from 'react-redux'
import activitySectionDropdownSelector from '../../../redux/selectors/activities/activitySectionDropdownSelector'
import Title from '../../layout/Title/Title'
import inviteNewAssessorValidation from '../../../models/assessor/inviteNewAssessorValidation'


const asyncValidate = (val, dispatch, props) => {
    const { values } = props

    const email = get(values, 'email')

    if (!email) {
        return new Promise(resolve => resolve())
    }

    const orgId = get(props, 'orgId')

    const activityCategoryId = get(values, 'activityCategory.id')

    return email && orgId && activityCategoryId && props.checkAssessorEmailAvailability(email, orgId,  activityCategoryId)
        .then(body => {
            if (!get(body, 'body.available')) {
                const bodyObj = get(body, 'body')

                let assessor = ''

                get(bodyObj, 'assessorList').forEach(a => {
                    assessor += get(a, 'name') + ' '
                })
                // eslint-disable-next-line
                throw {
                    email:
                        {
                            text: 'Assessor is already registered for the activity.',
                            intlKey: 'errors.assessor_already_registered'
                        }

                }
            }
        })
}

@form({
    form: 'invite-new-assessor',
    disableHook: true,
    asyncValidate: asyncValidate,
    validate: inviteNewAssessorValidation
})
@apiActivities({
    activityCategories: true
})
@apiCodeLists(['activitySections', 'titles'])
@injectIntl
@connect(({ api }) => ({
    dropdownSections: activitySectionDropdownSelector(api),
}))
class InviteNewAssessorModal extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func,
        modalId: PropTypes.string,
        modal: PropTypes.func,
        isLoading: PropTypes.bool,
        onApprove: PropTypes.func.isRequired,
        orgId: PropTypes.number.isRequired,
        activities: PropTypes.object.isRequired,
        codeLists: PropTypes.object.isRequired,
        dropdownSections: PropTypes.list,
        checkAssessorEmailAvailability: PropTypes.func.isRequired
    }

    handleSubmit = (fields, orgId) => {
        return this.props.onApprove(fields, orgId)
            .then(() => {
                this.props.onSubmit()
                this.props.reset()
            })
    }

    render() {
        const {
            modalId,
            modal,
            handleSubmit,
            isLoading,
            orgId,
            activities,
            values,
            intl,
            codeLists,
            dropdownSections
        } = this.props

        const parentId = get(values, 'activityCategory.parent.id')

        const section = get(values, 'activitySection')

        const disabledActivityType = !section

        const disabledActivity = !section && !get (values, 'activityCategory.parent.id')

         const mappedParents = mapActivitiesParents(activities.parents, section)

        const subcategoryValue = get(values, 'activityCategory.id')

        const isOthersSubCategory = ACTIVITY_CATEGORIES.other.id === subcategoryValue

        const mappedCategories = mapActivitiesCategories(
            activities.list,
            parentId,
            null
        )

        return (
            <Modal id={modalId} modal={modal} customActions>
                <div>
                    <form onSubmit={handleSubmit((fields) => this.handleSubmit(fields, orgId))}>
                        <div>
                            <Title h2 intlKey="moduleTitle.invite_new_assessor">
                                Invite new assessor
                            </Title>
                            <div>
                                <FormattedMessage
                                    id="label.invite_new_assessor_desc"
                                    defaultMessage="Provide basic information about the assessor and ORB
                                    will send him registration request for selected activity." />
                            </div>
                            <br />

                        <Select
                            label="Activity Section"
                            intlKey="label.section"
                            name="activitySection"
                            options={dropdownSections}
                        />
                        <Select
                            label="Activity Type"
                            intlKey="label.activity_type"
                            name="activityCategory.parent.id"
                            options={mappedParents}
                            disabled={disabledActivityType}
                            searchable
                            sorted
                        />
                        <Select
                            label="Activity"
                            intlKey="label.activity"
                            name="activityCategory.id"
                            disabled={disabledActivity}
                            options={mappedCategories}
                            sorted
                        />
                        {isOthersSubCategory &&
                        <Input
                            label="Other activity"
                            intlKey="label.other_activity"
                            name="activityCategory.name"
                            maxLength={512}
                        />}
                        </div>

                        <div className="row">
                            <div className="col-xs-6">
                                <Input
                                    label="Email"
                                    intlKey="label.email"
                                    name='email'
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-3">
                                <Select
                                    label="Title"
                                    intlKey="label.title"
                                    name="title"
                                    options={get(codeLists, 'titles.list')}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4">
                                <Input
                                    label="First name"
                                    intlKey="label.first_name"
                                    name='firstName'
                                />
                            </div>
                            <div className="col-xs-4">
                                <Input
                                    label="Middle name"
                                    intlKey="label.middle_name"
                                    name='middleName'
                                />
                            </div>
                            <div className="col-xs-4">
                                <Input
                                    label="Lastname"
                                    intlKey="label.last_name"
                                    name='lastName'
                                />
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-xs-12">
                                <Button
                                    type="button"
                                    secondary
                                    intlKey="button.close"
                                    onClick={() => this.props.modal(null)}
                                >
                                    Close
                                </Button>
                                <div style={{ marginBottom: '10px', float: 'right' }}>
                                    <Button type="submit" isLoading={isLoading}>
                                        <FormattedMessage id="button.invite" defaultMessage="Invite" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }
}

export default InviteNewAssessorModal
